<template>
    <div style="width:100%">
        <v-snackbar
                v-model="snackBar"
                :color="'primary'"
                :timeout="2000"
                :top="true">
            Profiles Updated
        </v-snackbar>
        <v-container fluid style="width:100%">
            <v-form model="valid">
                <div class="text-right pb-2">
                    <v-btn outlined color="success" @click="addPremiseProfile()">Add Premise Profile</v-btn>
                </div>
                <v-sheet
                        v-for="(pp,index) in premiseProfiles"
                        class="d-flex mb-2"
                        color="grey lighten-3"
                        style="width:100%">
                    <v-container fluid style="width:100%">
                        <v-layout row wrap style="width:100%">
                            <v-flex md4>
                                <v-select :items="premises"
                                          label="Select a Premise To Add Profile"
                                          item-text="name"
                                          v-bind:index="index"
                                          @change="premiseSelected(pp)"
                                          v-model="pp.premiseId"
                                          item-value="id"></v-select>
                            </v-flex>
                            <v-flex md4>
                                <v-select :items="pp.profiles"
                                          v-show="pp.profiles != null"
                                          label="Select a Profile"
                                          item-text="name"
                                          v-model="pp.profileId"
                                          item-value="id"></v-select>
                            </v-flex>
                            <v-flex md4>
                                <v-btn @click="deleteUserProfile(index)">Remove</v-btn>
                            </v-flex>
                        </v-layout>
                    </v-container>
                <v-divider class="py-2"></v-divider>
                </v-sheet>
                <v-layout>
                    <v-btn outlined type="button" @click="save()" color="success" :disabled="overlay">Save</v-btn>
                    <v-progress-circular
                            :width="3"
                            v-show="overlay"
                            color="red"
                            indeterminate="">
                    </v-progress-circular>
                </v-layout>
            </v-form>
        </v-container>
        <confirm-dialog ref="confirmDialog"></confirm-dialog>
    </div>
</template>

<script>
    import api from '@/api';
    import {validationMixin} from '@/mixins/validations'
    import ConfirmDialog from "@/components/common/ConfirmDialog";
    export default {
        inject : ['getProvidedUser','getProvidedUserOrg'],
        mixins:[validationMixin],
        components : {ConfirmDialog},
        data() {
            return {
                snackBar : false,
                userId: null,
                overlay : false,
                premises: [],
                organizations : [],
                user: null,
                premiseId: null,
                premiseProfiles: [],
                valid : true
            };
        },
        mounted() {
            this.user = this.getProvidedUser();
            this.organization = this.getProvidedUserOrg();
            this.getData();
        },
        created:function() {
            this.userId = this.$route.params.userId;
        },
        methods: {
            premiseSelected(pp) {
                this.getProfiles(pp.premiseId).then(list => {
                    pp.profiles = list;
                });
            },
            addPremiseProfile() {
              this.premiseProfiles.push({
                  premiseId: null,
                  profileId: null,
                  profiles: null
              });
            },
            deleteUserProfile(index) {
                const isPersisted = this.premiseProfiles[index].isPersisted;
                const profileId = this.premiseProfiles[index].profileId;
                if (isPersisted) {

                    this.$refs.confirmDialog.open('Remove Profile','Are You Sure?').then((confirm) => {
                        if (confirm) {
                            this.$root.$emit('showGlobalOverlay');
                            api.profile.user.del(profileId, this.userId).then(() => {
                                this.$root.$emit('hideGlobalOverlay');
                                this.setupUserProfiles();
                            });
                        }
                    });
                } else {
                    this.premiseProfiles.splice(index,1);
                }
            },
            getData() {
                api.premise.search({
                    pageNumber: 0,
                    pageSize: -1,
                    sortBy : 'name',
                    sortOrder : 'ASC',
                    organizationId : this.organization.id
                }).then(results => {
                    this.premises = results.list;
                    this.setupUserProfiles();
                }).finally(() => {

                });
            },
            setupUserProfiles() {
                this.$root.$emit('showGlobalOverlay');
                const that = this;
                api.user.profile.get(this.userId).then(userProfiles => {
                    const promises = userProfiles.map((pp) => {
                        return new Promise((resolve) => {
                            that.getProfiles(pp.premiseId).then((profiles) => {
                                pp.profiles = profiles;
                                pp.profileId = pp.id;
                                pp.isPersisted = true;
                                resolve();
                            });
                        });
                    });
                    Promise.all(promises).then(() => {
                        that.premiseProfiles = userProfiles;
                        this.$root.$emit('hideGlobalOverlay');
                    });
                });
            },
            getProfiles(premiseId) {
                return new Promise((resolve) => {
                        api.profile.search({
                            pageNumber: 1,
                            pageSize: -1,
                            sortBy: 'name',
                            sortOrder: 'ASC',
                            premiseId: premiseId
                        }).then(results => resolve(results.list));
                })
            },
            validate() {
                for (let i=0;i<this.premiseProfiles.length;i++) {
                    const pp = this.premiseProfiles[i];
                    if (!pp.profileId || !pp.premiseId) {
                        return false;
                    }
                }
                return true;
            },
            save() {

                if (!this.validate()) {
                    this.$root.$emit('globalError','Please Specify All Premise and Profiles');
                    return;
                }

                const that = this;
                that.snackBar = false;
                that.overlay = true;
                const promises = this.premiseProfiles.map((pp) => {
                    return new Promise((resolve,reject) => {
                        api.profile.user.post(pp.profileId, that.userId).then(resolve,reject);
                    });
                });
                Promise.all(promises).then(
                    () => {
                        that.snackBar = true;
                        that.overlay  = false;
                        that.setupUserProfiles();
                    }, (error) => {
                        this.processErrors(error);
                        that.snackBar = true;
                        that.overlay  = false;
                    }
                );
            },
            goBack() {

            }
        },
        name: "EditUserFirstAlert.vue"
    }
</script>
<style>
    form .flex {
        padding:8px;
    }
</style>